import { render, staticRenderFns } from "./StudentEnrollments.vue?vue&type=template&id=722bb20a&"
import script from "./StudentEnrollments.vue?vue&type=script&lang=js&"
export * from "./StudentEnrollments.vue?vue&type=script&lang=js&"
import style0 from "./StudentEnrollments.vue?vue&type=style&index=0&id=722bb20a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports